export default {
    introduction: {
        title: 'Zoeken in het Merkenregister en Handelsregister',
        body: 'Zet de naam die je voor je bedrijf of organisatie wilt gebruiken in de zoekbalk en klik op ‘Zoeken’. Zo controleer je of die naam al is vastgelegd als handelsnaam (bedrijfsnaam) of merknaam.',
        bodyLink: '/nl/ondernemers/faq#waar-moet-ik-op-letten-bij-het-gebruik-van-naamchecker',
        bodyLinkText: 'Lees waarmee je rekening mee moet houden',
        listHeading: 'Tips bij het zoeken',
        listPointOne: 'Zoek op delen van je naam. Dus als je naam  ‘Krissie Krassie Coaching’ is, zoek dan op ‘Krissie’ of  ‘Coaching’. Het is vooral belangrijk om op het meest unieke deel van je naam te zoeken.',
        listPointTwo: 'De tool kan niet op klank (fonetisch) zoeken, maar als jouw naam dezelfde klank heeft als een andere handelsnaam, kan dat verwarrend zijn. Zoek dus niet alleen op bijvoorbeeld ‘Daamen’, maar ook op ‘Damen’ en ‘Danen’.',
    },
    contender: {
        title: 'Wat betekent dit',
        listHeading: 'Check dit voordat je jouw naam gaat gebruiken',
        listPointOne: 'Controleer of je de naam in Google tegenkomt. Als iemand anders jouw handelsnaam al langer gebruikt, heeft die ander het oudste recht op die naam. Ook als de ander die naam niet in het KVK Handelsregister heeft laten vastleggen.',
        listPointTwo: 'Weet je echt zeker dat jouw naam nog vrij is?',
        listPointTwoUrlText: 'Lees dan verder op deze pagina.',
        bodyLinkText: 'Lees meer over het gebruik van de Naamchecker',
    },
    reminder: {
        body: 'Waar moet ik op letten? Lees meer over het gebruik van de ',
        namechecker: 'Naamchecker',
    },
    result: {
        type: 'Type: ',
    },
    results: {
        count: 'resultaat | resultaten',
    },
    resultsError: {
        title: 'Sorry, er gaat iets mis',
        body: 'Er is een storing waardoor we geen zoekresultaten kunnen laten zien. Kom later nog eens terug.',
    },
    search: {
        introTitle: 'Check of je naam al voorkomt',
        boipResultsTitle: 'BOIP Merkenregister',
        boipNoResults: 'Geen zoekresultaten voor merknamen.',
        boipCountResults: '{count} zoekresultaat voor merknamen. | {count} van {total} zoekresultaten voor merknamen.',
        boipResultsLinkText: 'Bekijk resultaten Merkenregister',
        kvkResultsTitle: 'KVK Handelsregister',
        kvkNoResults: 'Geen zoekresultaten voor handelsnamen.',
        kvkCountResults: '{count} zoekresultaat voor handelsnamen. | {count} van {total} zoekresultaten voor handelsnamen.',
        kvkResultsLinkText: 'Bekijk resultaten en uitzonderingen Handelsregister',
        resultsFound: '"{term}" komt al voor in het Merkenregister of Handelsregister',
        noResultsFound: 'Goed nieuws, "{term}" komt niet voor in het Merkenregister of Handelsregister',
        errorFound: '"{term}" kan niet worden gevonden door een technische fout in het Merkenregister of Handelsregister',
    },
    searchBox: {
        inputPlaceholder: 'Zoek in het BOIP Merkenregister en het KVK Handelsregister',
        buttonLabel: 'Zoek',
    },
    infoButton: {
        kvkButton: 'Informatie over handelsnamen',
        boipButton: 'Informatie over merken',
    },
    tradeMark: {
        applicationNumber: 'Depotnummer',
        depotDate: 'Depotdatum',
        goodsAndServices: 'Waren en diensten',
        goodsAndServicesPrefix: 'KL',
        resultInfo: 'Zie je hier resultaten? Klik dan op de link hieronder om verder op onderzoek uit te gaan.',
        resultsNoInfo: 'De naam die je hebt ingevuld komt niet voor in het Merkenregister. Dit betekent niet automatisch dat je de naam meteen kunt gebruiken.',
        faqText: 'Bekijk de veelgestelde vragen hieronder.',
    },
    branch: {
        applicationNumber: 'KVK-nummer',
        address: 'Adres',
        tradeName: 'Handelsnaam',
        tradeNames: 'Handelsnamen',
        resultInfo: 'Benieuwd naar alle resultaten? Of wil je weten of er uitzonderingen zijn waardoor je de naam toch kunt gebruiken?',
        resultsNoInfo: 'De naam die je hebt ingevuld komt niet voor in het Handelsregister, maar wel in het Merkenregister. Het kan zijn dat je een andere organisatie in de weg zit als je de naam gebruikt.',
    },
};
